import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import HeaderMobile from "../components/HeaderMobile";
import Footer from "../components/Footer";
import DrawerCart from "../components/DrawerCart";
import { store } from "../app/store";
import { useSelector, useDispatch } from "react-redux";
import { fetchCart, clearCart } from "../app/features/cart";
import {
  clearAuthen,
  selectAuthen,
  selectToken,
  selectTypeUser,
  selectUsername,
} from "../app/features/authen";
import {
  HomeFilled,
  InfoCircleFilled,
  InfoCircleOutlined,
  ShopFilled,
  TagFilled,
  UserOutlined,
} from "@ant-design/icons";
import { BackTop, Drawer, Dropdown, Menu, Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveCookies } from "../utils";
import { images } from "../assets";
import ScrollButton from "../components/ScrollButton";

const Social = () => {
  return (
    <div className="flex flex-col fixed bottom-16 right-4 bg-white shadow-lg z-50 p-2 rounded-full items-center">
      <button
        onClick={() => {
          window.open("https://zalo.me/1183268577689610249",
            "_blank",
            "noopener,noreferrer"
          );
        }}
      >
        <img src={images.zaloicon} className="w-[60px] h-[60px]" alt="" />
        <p className="text-[12px] mb-4 mt-1 font-bold"> 
        Chat Zalo
        </p>
      </button>
      <ScrollButton></ScrollButton>
    </div>
  )
}

export default function Root() {
  const token = useSelector(selectToken);
  const userName = useSelector(selectUsername);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const typeUser = useSelector(selectTypeUser);
  const authen = useSelector(selectAuthen);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  useEffect(() => {
    if (token) {
      store.dispatch(fetchCart);
    } else {
      store.dispatch(clearCart());
    }
  }, [token]);
  const menuInfo = (
    <Drawer
      onClose={onClose}
      open={open}
      placement="bottom"
      zIndex={1}
      className="drawer_mobile"
      height="230"
    >
      <Menu
        items={[
          {
            key: "1",
            label: token ? (
              <button
                onClick={async () => {
                  const objAuthen = {
                    drug_store: authen.drug_store,
                    token: authen.token,
                    userinfo: authen.userinfo,
                  };
                  await saveCookies(JSON.stringify(objAuthen));
                  window.open(
                    `${typeUser == "GDP"
                      ? "https://gdp-staging.sphacy.vn/"
                      : "https://gpp-staging.sphacy.vn/"
                    }`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                target={`_blank`}
                class=" py-3 px-0  flex justify-center menu w-full text-base font-bold"
              >
                HỆ THỐNG QUẢN LÝ
              </button>
            ) : (
              ""
            ),
          },
          {
            key: "2",
            label: token ? (
              <button
                onClick={() => {
                  dispatch(clearAuthen());
                }}
                target={token && `_blank`}
                class=" py-3 px-0  flex justify-center menu w-full text-base font-bold"
              >
                ĐĂNG XUẤT
              </button>
            ) : (
              ""
            ),
          },
        ]}
      />
    </Drawer>
  );

  return (
    <div className="w-full">

      <Header />
      <HeaderMobile />
      <div className="relative">
        <div className="_maskSearch hidden bg-[#00000080] absolute h-full w-full z-50" />
        <div className="flex justify-center mx-4 z-1">
          <div className="w-full sm:max-w-[1200px] ">
            <Outlet />
          </div>
        </div>
        <Footer />
        <Social />

        <div className="sticky bottom-0 z-10 z-50 pt-2">
          <div className="p-2.5	flex flex-row md:hidden bg-white shadow-lg	bottom-menu">
            <Link
              to="/"
              className={`flex flex-1 flex-col text-[10px] items-center ${pathname == "/" ? `text-main-blue` : `text-[#9D9D9D]`
                }`}
            >
              <HomeFilled className="text-[14px] mb-1 " />
              Trang chủ
            </Link>
            <Link
              to="/category-list"
              className={`flex flex-1 flex-col text-[10px] items-center ${pathname == "/category-list"
                  ? `text-main-blue`
                  : `text-[#9D9D9D]`
                }`}
            >
              <TagFilled className="text-[14px] mb-1" />
              Sản phẩm
            </Link>
            <Link
              to="/agency"
              className={`flex flex-1 flex-col text-[10px] items-center ${pathname == "/agency" ? `text-main-blue` : `text-[#9D9D9D]`
                }`}
            >
              <ShopFilled className="text-[14px] mb-1" />
              Đại lý
            </Link>
            <Link
              to="/contact"
              className={`flex flex-1 flex-col text-[10px] items-center ${pathname == "/contact" ? `text-main-blue` : `text-[#9D9D9D]`
                }`}
            >
              <InfoCircleFilled className="text-[14px] mb-1" />
              Thông tin
            </Link>
            <div className="flex flex-1 flex-col text-[10px] items-center text-[#9D9D9D]">
              {token ? (
                <>
                  <UserOutlined
                    onClick={showDrawer}
                    className="text-[14px] mb-1"
                  />
                  Cá nhân
                  {menuInfo}
                </>
              ) : (
                <Link to="/signin">
                  {" "}
                  <UserOutlined
                    onClick={showDrawer}
                    className="text-[14px] mb-1 flex flex-1 flex-col items-center"
                  />
                  Cá nhân
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <DrawerCart />
    </div>
  );
}
